import React from 'react'
import TWControls from '../controls/TWControls'
import { Form } from '../controls/useForm'

const PortfolioLocationRemovePopup = ({ locationRemove, location }) => {
	const submitHandler = e => {
		locationRemove(location)
	}

	return (
		<Form onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12">
					<h2 className="newLocation__imageHolder">NOTICE! </h2>
				</div>
				<div className="col-span-12">
					<p>This will remove the location '{location.assetName}' from this portfolio. </p>
					<p>
						All of {location.assetName}'s notes, partners, tasks, files and images are preserved and
						remain available through {location.assetName}'s individual record in Locations.{' '}
					</p>
				</div>
				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.Button size="small" type="submit" text="Delete" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default PortfolioLocationRemovePopup
